const state = {
  isLoading: false,
  loadingIcon: "fa-regular fa-clock fa-5x",
  printoutLink: "",
  isDebug: false,
  isInManagement: true
};

export default state;
